import { Box, Divider, Text } from "@chakra-ui/react";
import { round } from "../utils/mathsHelper";
import TotalCostDetailsTable from "./TotalCostDetailsTable";
import { getSplitAddress } from "../utils/addressHelper";

export default function TotalCostDetailsCard({deliveryAddress, fullName, isSmallScreen, orderDetails}) {
    // We need to split the address onto two lines
    const addressParts = getSplitAddress(deliveryAddress);

    return (
        <>
            {orderDetails && (
                <Box width="100%" paddingX={isSmallScreen ? "0" : "1rem"} marginBottom="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                    <Text paddingY="1.5rem" paddingLeft="1rem" fontSize="medium" fontWeight="extrabold">Review your order</Text>
                    <Box width="100%" backgroundColor="blue.100">
                        <Box padding="2rem">
                            <Text fontWeight="extrabold" fontSize="xs">Delivering to</Text>
                            <Text fontSize="small">{fullName}</Text>
                            <Text fontSize="small">{addressParts.addressLineOne}</Text>
                            <Text fontSize="small">{addressParts.addressLineTwo}</Text>
                        </Box>
                    </Box>
                    <TotalCostDetailsTable orderDetails={orderDetails} />
                    <Divider />
                    <Box textAlign="end" paddingRight="2rem" paddingY="2rem">
                        <Text fontWeight="extrabold" fontSize="xs">Order total</Text>
                        <Text fontSize="small">Upfront Cost: ${round(orderDetails.totalInitialFees, 2)}</Text>
                        <Text fontSize="small">Service Charge: ${round(orderDetails.totalAnnualFees, 2)}</Text>
                    </Box>
                </Box>
            )}
        </>
    );
}